import React, { useEffect, useState } from 'react'
import commonStyles from "../PaymentDrawer.styles"
import styles from "./AddressInformationCard.styles"
import TextInput from '../../../../components/input/textinput/TextInput'
import SelectDropdown from '../../../../components/dropdown/selectdropdown/SelectDropdown'
import { componentKey as dataLoaderKey } from '../../../loaders/dataloader/DataLoaderSlice'
import { componentKey as paymentDrawerComponentKey, setPaymentAddressDetails } from '../PaymentDrawerSlice'
import { useDispatch, useSelector } from 'react-redux'
import Button from '../../../../components/button/Button'
import useGarbageCollector from '../../../../../libs/garbagecollector/garbageCollectorHooks'
import { componentKey, setAddressInformation, setAllRequiredFieldsTouched, setSalexTaxCalculationSuccessfull, setSelectedAddress } from './AddressInformationCardSlice'
import GeneralValidator, { generalValidator } from '../../../../../libs/utility/validators/GeneralValidator'
import { getCountriesAndStatesList } from '../../../loaders/dataloader/DataLoaderSaga'
import { calculateSalesTax, validateZipCode } from './AddressInformationCardSaga'
import { addNotifications } from '../../../toaster/ToasterPortalSlice'
import Loadable from '../../../../components/loadable/Loadable'
import { ADDRESS_INFORMATION_LOADING_STATES, ADDRESS_INFORMATION_MESSAGE_MAP } from './constants'
import VerticalSeparator from '../../../../components/separator/verticalseparator/VerticalSeparator'
import BasicCard from '../../../../components/card/basiccard/BasicCard'
import Heading from '../../../../components/heading/Heading'
import { VEC_ICON_NAME } from '../../../../components/icons/constants'
import AddNewAddress from './addnewaddress/AddNewAddress';

export const AddressInformationCard = ({
    totalAmount = 0,
    uspsMailingAmount = 0,
    uspsAmount = 0,
    savedCard = "",
    isUsps = false,
    isSubscription = false,
    subscriptionAmount = 0,
    showCalculateSalesTax = true,
    salesTaxSuccessCb = (salesTax) => { },
}) => {

    const dispatch = useDispatch();

    const { loadingState, allRequiredFieldsTouched, selectedAddress, zipCodeValidationSuccess, addressInformation, salesTax, salexTaxCalculationSuccessfull, showSavedAddress } = useSelector(state => state[componentKey]);
    const { countriesList, statesList } = useSelector(state => state[dataLoaderKey]);
    const { savedAddress } = useSelector(state => state[paymentDrawerComponentKey]);

    const { Address, Country, State, City, ZIP, Email } = addressInformation;


    useEffect(() => {
        if (countriesList.length <= 0 || statesList.length <= 0) {
            dispatch(getCountriesAndStatesList())
        } else {
            setDefaultCountry();
        }
    }, []);

    useEffect(() => {
        setDefaultCountry();
    }, [countriesList]);

    useEffect(() => {
        if (salexTaxCalculationSuccessfull) {
            salesTaxSuccessCb(salesTax, addressInformation);
        }
    }, [salexTaxCalculationSuccessfull]);

    useEffect(() => {
        dispatch(setSalexTaxCalculationSuccessfull(false))
    }, [State, ZIP])

    const onChangeHandler = (event, rules) => {
        const { name, value } = event.target;

        if (rules) {
            const errors = generalValidator.validate(value, rules);
            dispatch(setAddressInformation({ [name]: { value, errors, rules } }))
        } else {
            dispatch(setAddressInformation({ [name]: { value } }))
        }
    }

    const setDefaultCountry = () => {
        const USA = countriesList.find(c => c.Country_code == "US");

        if (USA) {
            dispatch(setAddressInformation({ ["Country"]: USA }))
        }
    }

    const handleSavedAddressClick = (address) => {
        const addressObj = address.value;
        dispatch(setAddressInformation({ City: { value: addressObj.City },
            State: statesList.find( state => state.value === addressObj.State ) ?? { value: addressObj.State },
            ZIP: { value: addressObj.ZipCode },
            Country: { value: addressObj.Country },
            Address: { value: addressObj.Address1 }
        }))
        dispatch(setSelectedAddress(address))
    }

    useEffect(() => {
        if(!showCalculateSalesTax) {
            dispatch(setPaymentAddressDetails(addressInformation))
        }
    }, [addressInformation])

    return (
        <>
            <div style={{ ...commonStyles.formContainer }}>
                <AddNewAddress />
                {
                    showSavedAddress &&
                    <SelectDropdown
                        label="Select Address"
                        name="address"
                        options={savedAddress.map(addressObj => ({ label: `${`${addressObj?.Address1},` ??''} ${addressObj?.City ??''} ${addressObj?.State ??''} ${addressObj?.Country ??''} ${addressObj?.ZipCode ??''}`, value: addressObj}))}
                        dropdownContainerStyles={styles.fullWidth}
                        value={selectedAddress}
                        onSelectCb={(name, selectedOption) => handleSavedAddressClick(selectedOption)}
                        dropdownMenuStyle={styles.fullWidth}
                    />
                }
                <TextInput
                    label="Email"
                    name="Email"                    
                    type="email"
                    placeHolder='Enter your email address'
                    value={Email?.value}
                    onChangeCb={onChangeHandler}
                    rules={Email?.rules}
                    errors={Email.errors}
                    formSubmitted={allRequiredFieldsTouched}
                />
                {
                    showCalculateSalesTax
                    &&
                    <Loadable
                        currentState={loadingState.state}
                        loadingStates={[ADDRESS_INFORMATION_LOADING_STATES.CALCULATE_SALES_TAX_LOADING]}
                        messageMap={ADDRESS_INFORMATION_MESSAGE_MAP}
                        isNewLoadable={true}
                    >
                        <Button onClickCb={() => {

                            dispatch(setAllRequiredFieldsTouched(true))

                            if (GeneralValidator.validateRequiredFields(addressInformation)) {
                                dispatch(addNotifications({ heading: "Please enter valid data", message: "To continue, please enter the valid address data" }))
                                return;
                            } else if (!zipCodeValidationSuccess && !selectedAddress?.value) {
                                dispatch(addNotifications({ heading: "Please validate the zip code", message: "To continue, please enter the valid zip code" }))
                                return;
                            }

                            dispatch(calculateSalesTax({
                                Address,
                                Country,
                                State,
                                City,
                                ZIP,
                                isUsps,
                                isSubscription,
                                TotalAmount: totalAmount,
                                UspsMailing: uspsMailingAmount,
                                UspsAmount: uspsAmount,
                                SavedCardValue: savedCard,
                                SubscriptionAmount: subscriptionAmount
                            }))
                        }}>Calculate Sales Tax</Button>
                    </Loadable>
                }
            </div>
        </>
    )
}
